import isEmpty from "lodash-es/isEmpty";
import {
  EfsMelcoEfsModelsMappingFileAttribute,
  EfsMelcoEfsModelsSchemaListItem,
} from "melco-shared-logic";
import { DisplayDataSource } from "../inputFormats/DisplayDataSource";

type DisplayFoldernameRuleValueProps = {
  filenameRule: EfsMelcoEfsModelsMappingFileAttribute;
  dataAssignments: EfsMelcoEfsModelsSchemaListItem[];
};

export const DisplayFoldernameRuleValue: React.FC<
  DisplayFoldernameRuleValueProps
> = ({ filenameRule, dataAssignments }) => {
  const { value, format_detail_id: dataSourceId } = filenameRule;

  if (!isEmpty(dataSourceId)) {
    return (
      <DisplayDataSource
        dataSourceId={dataSourceId!}
        dataAssignments={dataAssignments}
      />
    );
  }

  return <span>{value}</span> ?? null;
};
